import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { ToasterService, ToasterConfig, Toast, BodyOutputType } from 'angular2-toaster';

import 'style-loader!angular2-toaster/toaster.css';
import { DefinicaoSenhaModel } from '../login/definicao-senha/definicao-senha.model';
import { LoaderService } from './loader/loader.service';


@Injectable()
export class AuthService {

	apiUrl: string;
    logado= false;
	constructor(private router: Router, private http: HttpClient, private loader:LoaderService) {
        this.apiUrl = environment.apiUrl;
        this.logado = this.isLoggedIn();
	}

	private showToast(type: string, title: string, body: string) {

		var toast: Toast = {
			type: type,
			title: title,
			body: body,
			timeout: 2000,
			showCloseButton: true
		};
		// this.toasterService.pop(toast);
	}
	esqueciSenha(login:any){
		return this.http.post(this.apiUrl + "/login/esqueci-senha", login);
	}

	definicaoSenha(model: DefinicaoSenhaModel) {
		this.loader.show();
		this.http.post(this.apiUrl + "/login/definir-senha", model).subscribe(data => {
			this.loader.show();
			if (data['Retorno'].Authenticated) {
				this.setSession(data['Retorno']);
				this.router.navigate(['pages', 'usuarios']);
			} else {
				this.showToast("erro", "Falha", data['mensagem']);
			}
		});

	}
	login(login: any) {
		return this.http.post(this.apiUrl + "/login", login);
	}
	logout() {
        localStorage.removeItem("perfil");
        localStorage.removeItem("token");
        localStorage.removeItem("idusuario");
        localStorage.removeItem("possuiVinculos");
        localStorage.removeItem("expiration");
        this.logado = false;
        this.router.navigate(['login']);
        
	}

	public isLoggedIn() {
		return moment().isBefore(this.getExpiration());
	}

	isLoggedOut() {
		return !this.isLoggedIn();
	}

	getExpiration() {
		const expiration = localStorage.getItem("expiration");
		const expiresAt = JSON.parse(expiration);
		return moment(expiresAt);
	}

	setSession(authResult) {
		const expiresAt = moment(authResult.Expiration);
        localStorage.setItem('perfil', authResult.Perfil);
        localStorage.setItem('token', authResult.Token);
        localStorage.setItem('possuiVinculos', authResult.PossuiVinculos);
        localStorage.setItem("idUsuario", authResult.IdUsuario);
        localStorage.setItem("expiration", JSON.stringify(expiresAt.valueOf()));
        
        if(authResult.Perfil =="cliente")
        this.router.navigate(['pages', 'usuarios','detalhe',authResult.IdUsuario]);
        else
            this.router.navigate(['pages', 'usuarios'],{queryParams : {l:true}});
        
	}
}




// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts